module.exports = __webpack_public_path__ + "static/media/9DESA26.030cd7ad.jpg";